import FolderIcon from './folder';
import TrashIcon from './trash';
import CopyIcon from './copy';
import PlusIcon from './plus';
import './styles.css';

export {
  FolderIcon,
  TrashIcon,
  CopyIcon,
  PlusIcon,
};



// WEBPACK FOOTER //
// ./src/components/icons/index.jsx